__turbopack_context__.v({
  "className": "circularstdfont_70798e2f-module__zqtd1G__className",
  "variable": "circularstdfont_70798e2f-module__zqtd1G__variable",
});
